import React, { Component } from "react";
import LearnAndWriteChar from "./LearnAndWriteChar";

class LearnAndWriteMutipleChar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isshown: false
    }
  }

  handleClick = () => {
    this.setState({isshown: !this.state.isshown});
  }

  render () {
    return (
      <div>
        <button onClick={this.handleClick}>Next</button>
        <div className={this.state.isshown ? "hidden" : ""}>
          <LearnAndWriteChar character="额" />
        </div>
        <div className={!this.state.isshown ? "hidden" : ""}>
          <LearnAndWriteChar character="为" />
        </div>
        <LearnAndWriteChar character="儿" />
      </div>
    );
  }

  static defaultProps = {
    chars: ["为", "额"]
  }
}

export default LearnAndWriteMutipleChar;